module.exports = __webpack_public_path__ + "static/media/lawsuit_gavel.99a23209.jpg";